import React from 'react';
import useGetPishNahad from './hooks/useGetPishNahad';
import SurveyList from '../PatientSurveyList/components/SurveyList';
import Survey from '../PatientSurveyList/components/Survey';
import { sortLatestDate } from '../PatientSurveyList/functions/sortLatestDate';
import { LinearProgress } from '@mui/material';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

const UserFeedback = () => {
  const data = useGetPishNahad();
  const screenWidth = useCheckScreenWidth();


  console.log('data-->',data)

  return (
    <React.Fragment>
      <div
        style={{
          paddingInline: screenWidth > 1024 ? '5em' : '',
        }}
      >
        <SurveyList>
          {data === 'loading' ? (
            <LinearProgress />
          ) : (
            sortLatestDate(data)?.map((survey) => (
              <Survey key={survey?.Id} survey={survey} />
            ))
          )}
        </SurveyList>
      </div>
    </React.Fragment>
  );
};

export default UserFeedback;
